// extracted by mini-css-extract-plugin
export default {"watchList":"WatchList_watchList__TjSpR","list":"WatchList_list__4rXaq","listItem":"WatchList_listItem__wiux8"};